/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import "url-search-params-polyfill";

export const handleTestKey = (locationSearch: string) => {
  const query = new URLSearchParams(locationSearch);
  if (query.has("testKey")) {
    localStorage.setItem("testKey", query.get("testKey")!);
  }
};

export const accessGranted = (locationSearch: string) => {
  if (navigator.userAgent === "ReactSnap") {
    return true;
  }
  handleTestKey(locationSearch);
  return process.env.REACT_APP_DEPLOYMENT !== "testing" || localStorage.getItem("testKey") === "bird";
};
